import React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router';

// Config
import { config } from '../../config';

// Helpers
import { getCookie, getURLSegment, toggleDrawer } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Dependencies
import DOMPurify from 'dompurify';

// Components
import * as icons from '../Icons/Icons';
import Drawer from '../Drawer/Drawer';
import ScheduleAutomated from '../StudentDashboard/ScheduleAutomated';

const ChooseProctorType = observer(class ChooseProctorType extends React.Component {
  constructor() {
    super();

    // Bind this to functions
    this.initSchedule = this.initSchedule.bind(this);
    this.setStatus = this.setStatus.bind(this);
    this.messageInstructor = this.messageInstructor.bind(this);
    this.setProctorLocationSid = this.setProctorLocationSid.bind(this);
  }

  componentWillMount() {
    const { SessionStore } = this.props.store;

    this.state = {
      drawerOpen: false,
      drawerContent: null,
      proctorLocationSid: null,
      proctorTypeSubCategorySid: null,
      examSid: null,
      sessionSid: null,
      status: null,
      accessCode: null,
      messageSid: null,
      schedulingOpen:true
    }

    const examSid = getURLSegment(this, 3);
    const sessionSid = getURLSegment(this, 5);

    SessionStore.getProctorTypes();
    this.getProctorGroups(examSid, sessionSid);
    this.getExam(examSid, sessionSid);
  }

  getProctorGroups(examSid, sessionSid) {
    this.props.store.ProctorStore.getSessionProctorGroups(examSid, sessionSid, null, this.setProctorLocationSid);
  }

  getExam(examSid, sessionSid) {
    // Get exam
    this.props.store.ExamStore.getExam(examSid);

    // Get exam session
    this.props.store.ExamStore.getExamSession(examSid, sessionSid, this.setStatus);
  }

  setStatus(response) {
    const { BlackoutStore, ExamStore, ScheduleStore } = this.props.store;
    const { examConfiguration } = ExamStore.examSession;

    this.setState({
      status: response.data.status
    });

    if(response.data.accessKey) {
      this.setState({
        accessCode: response.data.accessKey
      });
    }

    // Cancel pre-existing reservations
    if(response.data.externalReservedAppointmentId) {
      ScheduleStore.cancelReservation(response.data.examSid, response.data.sid);
    }

    // Check for blackout dates
    const query = {
      startDate: examConfiguration.examOpenDate,
      endDate: examConfiguration.examCloseDate
    };

    BlackoutStore.listBlackoutDates(query);
  }

  renderIcon(icon) {
    switch (icon) {
      case 'person':
        return <icons.iconIndividual />

      case 'attended':
        return <icons.iconAttended />

      case 'unattended':
        return <icons.iconUnattended />

      case 'instructor':
        return <icons.iconInstructor />

      case 'testing_centers':
        return <icons.iconTestingCenters />

      case 'testing_centers_individuals':
        return <icons.iconCentersIndivuals />

      case 'examity':
        return <icons.iconExamity />

      case 'proctoru':
        return <icons.iconProctorU />

      case 'hybrid':
        return <icons.iconLaptop />

      default:
        return ''
    }
  }

  // Output the correct module
  proctorTypeModule(thisType) {
    const { SessionStore } = this.props.store;
    let module = '';

    // If this group only has one type
    if(thisType.length === 1) {
      // Loop through parent categories
      SessionStore.proctorTypeList.map(
        (key, i) => {
          return (
            // Loop through subcategories and this proctor type category
            key.subCategories.filter(function(obj){
              return obj.sid === thisType[0]
            }).map(
              (subCategory, i) => {
                module = subCategory.module;
                return module;
              }
            )
          )
        }
      )
    }
    return module;
  }

  renderButton(schedulingModule, proctorGroup) {
    const { translation } = this.props;
    const { proctorTypes, proctorLocationSid, buttonText, workflowModule } = proctorGroup
    const groupSid = proctorGroup.sid;

    // Get url segments
    const segment1 = getURLSegment(this, 1);
    const segment2 = getURLSegment(this, 2);
    const examSid = getURLSegment(this, 3);
    const segment4 = getURLSegment(this, 4);
    const sessionSid = getURLSegment(this, 5);
    const segment6 = getURLSegment(this, 6);
    const configurationSid = getURLSegment(this, 7);

    if(workflowModule && workflowModule === 'hybrid') {
      // If the proctor group has a hybrid workflow module
      return (
        <button
          className="btn btn--action btn--icn-right"
          onClick={(e) => {this.initSchedule(e, 'ScheduleAutomated', proctorGroup.proctorLocationSids[0], sessionSid, examSid, null, proctorTypes[0])}}
        >
          {buttonText || translation.button}
          <icons.iconCircleRight className="icon" />
        </button>
      )
    } else {
      // Figure out which button to show
      switch (schedulingModule) {
        case 'bvirtual-attended':
        case 'online-attended':
          return (
            <button
              className="btn btn--action btn--icn-right"
              onClick={(e) => {this.initSchedule(e, 'ScheduleOnline', proctorLocationSid)}}
              data-location={proctorLocationSid}
            >
              {buttonText || translation.button}
              <icons.iconCircleRight className="icon" />
            </button>
          )

        case 'instructor':
          return (
            <button
              className="btn btn--action btn--icn-right"
              onClick={(e) => {this.initSchedule(e, 'ScheduleInstructor', proctorLocationSid)}}
            >
              {buttonText || translation.button}
              <icons.iconCircleRight className="icon" />
            </button>
          )

        case 'vtc':
          return (
            <button
              className="btn btn--action btn--icn-right"
              onClick={(e) => {this.initSchedule(e, 'ScheduleVTC', proctorLocationSid, sessionSid, examSid)}}
            >
              {buttonText || translation.button}
              <icons.iconCircleRight className="icon" />
            </button>
          )

        case 'automated':
          return (
            <button
              className="btn btn--action btn--icn-right"
              onClick={(e) => {this.initSchedule(e, 'ScheduleAutomated', proctorLocationSid, sessionSid, examSid, null, proctorTypes[0])}}
            >
              {buttonText || translation.button}
              <icons.iconCircleRight className="icon" />
            </button>
          )

        case 'hybrid_scheduling':
          return (
            <button
              className="btn btn--action btn--icn-right"
              onClick={(e) => {this.initSchedule(e, 'ScheduleHybrid', proctorLocationSid, sessionSid, examSid, groupSid, proctorTypes[0])}}
            >
              {buttonText || translation.button}
              <icons.iconCircleRight className="icon" />
            </button>
          )

        case 'hybrid_tiered_scheduling':
          return (
            <button
              className="btn btn--action btn--icn-right"
              onClick={(e) => {this.initSchedule(e, 'ScheduleHybrid', proctorLocationSid, sessionSid, examSid, groupSid, proctorTypes[0])}}
            >
              {buttonText || translation.button}
              <icons.iconCircleRight className="icon" />
            </button>
          )

        default:
          return (
            <Link
              className="btn btn--action btn--icn-right"
              to={`${segment1}/${segment2}/${examSid}/${segment4}/${sessionSid}/${segment6}/${configurationSid}/search/group/${groupSid}`}
              onClick={() => {this.setProctorTypes(proctorTypes)}}
            >
              {buttonText || translation.button}
              <icons.iconCircleRight className="icon" />
            </Link>
          );
      }
    }
  }

  initSchedule(e, type, proctorLocationSid, sessionSid, examSid, proctorGroupSid, proctorTypeSubCategorySid) {
    this.setState({
      proctorLocationSid
    });

    if(sessionSid) {
      this.setState({
        sessionSid
      });
    }

    if(examSid) {
      this.setState({
        examSid
      });
    }

    if(proctorGroupSid) {
      this.setState({
        proctorGroupSid
      });
    }

    if(proctorTypeSubCategorySid) {
      this.setState({
        proctorTypeSubCategorySid
      });
    }

    toggleDrawer(e, this, type);

    this.props.store.ProctorStore.proctorLocationSid = proctorLocationSid;
  }

  setProctorTypes(proctorTypes) {
    this.props.store.ProctorStore.proctorCategories = proctorTypes;
  }

  messageInstructor() {
    const examSid = getURLSegment(this, 3);

    this.setState({
      examSid: examSid,
      messageSid: null
    });

    toggleDrawer(null, this, 'MessageThread');
  }

  setProctorLocationSid(proctorGroups) {
    const { automatedProctorTypeSids } = config;
    const { automatedOnly } = this.props;
    const automatedProctorGroups = [];

    // If this is automated only, get the proctorLocationSid
    if(proctorGroups.length > 0 && automatedOnly) {
      proctorGroups.forEach(group => {
        if(group.proctorTypes.length === 1 && automatedProctorTypeSids.indexOf(group.proctorTypes[0]) > -1) {
          automatedProctorGroups.push(group);
        }

        if(this.props.scheduleClosed){
          if( group.workflowModule === 'automated') {
            this.setState({proctorLocationSid: group.proctorLocationSid})
          }
        }
      });

      // Make sure there is only one automated proctor group
      // before setting the proctorLocationSid. If there is
      // more than one, the user will see the choose proctor
      // type view. Otherwise, they will go straight to
      // automated scheduling.

      if(automatedProctorGroups.length === 1) {
        this.setState({
          proctorLocationSid: automatedProctorGroups[0].proctorLocationSid
        });
      } else {
        this.setState({
          multipleAutomatedGroups: true
        });
      }
    } else if(proctorGroups.length === 0) {
      this.setState({
        noAutomatedGroup: true
      });
    }
  }

  renderResults() {
    const { translation } = this.props;
    const { ProctorStore, SessionStore } = this.props.store;

    if(!SessionStore.loading) {
      if(ProctorStore.proctorGroups.length > 0) {
        return(
          <div className="wrap wrap--brief">
            <ul className="block-list">
              {ProctorStore.proctorGroups.map(
                (key, i) =>
                <li key={i} className="block-list__block media--alt">
                  {this.renderIcon(key.icon)}

                  <div className="media__copy">
                    <strong className="block-list__title">{key.title}</strong>

                    <div
                      className="block-list__description"
                      dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(key.description)}}
                    ></div>

                    {
                      this.renderButton(
                        this.proctorTypeModule(key.proctorTypes),
                        key
                      )
                    }
                  </div>
                </li>
              )}
            </ul>
          </div>
        )
      } else {
        return (
          <div className="wrap">
            <span className="no-results">
              {translation.no_groups} <button className="btn--link" onClick={this.messageInstructor}>{translation.no_groups_button}</button>
            </span>
          </div>
        )
      }
    }

    return null;
  }

  render() {
    const { automatedOnly, translation, scheduleClosed } = this.props;
    const { SessionStore } = this.props.store;

    let toUserSid = null;

    if(SessionStore.courseData.instructor) {
      toUserSid = SessionStore.courseData.instructor.sid;
    } else {
      if(SessionStore.hasSessionStorage) {
        toUserSid = JSON.parse(sessionStorage.getItem('courseData')).instructor.sid;
      } else {
        toUserSid = JSON.parse(getCookie('courseData')).instructor.sid;
      }
    }

    if (!automatedOnly || (this.state.multipleAutomatedGroups && !scheduleClosed)) {
      return (
        <main tabIndex="-1" id="main-content" className="page" aria-labelledby="page-title">
          <header className="page__header">
            <div className="wrap">
              <h1 id="page-title" className="page__title">{translation.page_title}</h1>
            </div>
          </header>

          {this.renderResults()}

          <Drawer
            content={this.state.drawerContent}
            isOpen={this.state.drawerOpen}
            parent={this}
            proctorGroupSid={this.state.proctorGroupSid}
            proctorLocationSid={this.state.proctorLocationSid}
            proctorTypeSubCategorySid={this.state.proctorTypeSubCategorySid}
            examSid={this.state.examSid}
            sessionSid={this.state.sessionSid}
            status={this.state.status}
            accessCode={this.state.accessCode}
            messageSid={this.state.messageSid}
            toUserSid={toUserSid}
            contextType="examSid"
            contextId={this.state.examSid}
            {...this.props}
          />
        </main>
      )
    } else if(automatedOnly && this.state.noAutomatedGroup) {
      return (
        <main tabIndex="-1" id="main-content" className="page">
          <div className="panel panel--medium">
            <h2 className="panel__title panel__title--alt">
              {translation.no_automated_group.heading}
            </h2>

            <p>{translation.no_automated_group.body}</p>
          </div>
        </main>
      )
    } else if(automatedOnly && this.state.status && this.state.proctorLocationSid) {
      return (
        <main tabIndex="-1" id="main-content" className="page">
          <ScheduleAutomated
            parent={this}
            examSid={getURLSegment(this, 3)}
            sessionSid={getURLSegment(this, 5)}
            status={this.state.status}
            proctorLocationSid={this.state.proctorLocationSid}
            {...this.props}
          />
        </main>
      )
    }

    return null;
  }
})

export default translate('ChooseProctorType')(ChooseProctorType);

// Questions
// * Should instructor as proctor be mutually exclusive?
// * Should anything that is not mutually exclusive always go to the find a proctor page?



// WEBPACK FOOTER //
// ./src/app/components/StudentDashboard/ChooseProctorType.js